import styled from 'styled-components6';

export const HideOnMDScreen = styled.div`
    @container header (max-width: 950px) {
        display: none;
    }
    @container media-footer (max-width: 750px) {
        display: none;
    }
    @container modal-footer (max-width: 750px) {
        display: none;
    }
    white-space: nowrap;
    text-wrap: none;
`;
